<template>
    <div class="container">

        <!--<h1>{{ msg }}</h1>-->
        <h4>첫번째 질문입니다.</h4>
        <p>질문에 대한 설명입니다.</p>
        <input type="text" class="form-control" v-model="msg">
        
        <div>
            <b-form-datepicker v-model="value" :min="min" :max="max" locale="kr"></b-form-datepicker>
        </div>
    </div>
</template>


<script>

//import "bootstrap/dist/css/bootstrap.css";
import numeral from "numeral";
//import Vue from "vue";

export default {
    name: 'App',
    methods: {
        toCurrency: function(event) {
            console.log(event);
        }
    },
    data() {

        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        // 15th two months prior
        const minDate = new Date(today)
        minDate.setMonth(minDate.getMonth() - 2)
        minDate.setDate(15)
        // 15th in two months
        const maxDate = new Date(today)
        maxDate.setMonth(maxDate.getMonth() + 2)
        maxDate.setDate(15)


        return { 
            message : '1234',
            msg : 'tst',
            value: '',
            min: minDate,
            max: maxDate
        }
    },
    watch : {
        msg : function(val) {
            this.msg = numeral(val).format("0,0");
            //console.log(val);
        }
    }
}

</script>